// Lib
import { createApi } from "@reduxjs/toolkit/query/react";
// Types
import { UrlQueryParams } from "types/common";
import { GetServerLogsResponseDto } from "types/serverLogs";
// Helpers
import { serverLogsUrlBuilder } from "./urlBuilder/serverLogs";
// Utils
import { coreQuery } from "utils/baseQuery";

export const serverLogsAPI = createApi({
  reducerPath: "serverLogsAPI",
  baseQuery: coreQuery(),
  tagTypes: ["server-logs"],

  endpoints: build => ({
    getServerLogs: build.query<
      GetServerLogsResponseDto,
      { query: UrlQueryParams }
    >({
      query: ({ query }) => ({
        url: serverLogsUrlBuilder.getServerLogs({ query }),
        method: "GET",
      }),
      providesTags: ["server-logs"],
    }),
  }),
});

export const { useGetServerLogsQuery } = serverLogsAPI;
